<template>
  <div class="col-12" style="position: relative">
    <div class="w-100 bg-danger py-2 d-flex align-items-center justify-content-center" v-if="isRequested">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
        class="bi bi-info-circle-fill mx-2" viewBox="0 0 16 16">
        <path
          d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
      </svg>
      Admin Requested For Reupload Files!
    </div>

    <div v-else></div>
    <div v-if="details && !details.is_paid && !loadingCredits" class="px-3">
      <div v-if="creditByCategory < 1" class="alert alert-warning" role="alert">
        Hi there! This track will require <b>1</b> credit of <b>{{ getCategoryTitle(details.category) }}</b>. You have
        <b>{{
          creditByCategory }}</b>. <span @click="purchaseCredits" class="message-action">
          <b>Click here to
            purchase credits of <b>{{ getCategoryTitle(details.category) }}</b>.</b>
        </span>
      </div>

      <div v-if="creditByCategory > 0" class="alert alert-warning" role="alert">
        Hi there! This track will require 1 credit of <b><i>{{ getCategoryTitle(details.category) }}</i></b>. You have
        <b>{{
          creditByCategory }} <i>{{ getCategoryTitle(details.category) }}</i></b>.

        <button type="button" data-toggle="modal" data-target="#confirmModal" class="btn btn-success">Apply Credit
          (1)</button>
      </div>
    </div>

    <div class="floating-btn-back d-flex align-items-center p-2" @click="back">
      <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="#fff" class="bi bi-arrow-left-circle-fill mx-2"
        viewBox="0 0 16 16">
        <path
          d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z" />
      </svg>
    </div>


    <div
      class="container-fluid col-11 d-flex flex-column flex-sm-column flex-md-row flex-lg-row flex-xl-row justify-content-between align-items-center">
      <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 my-1">
        <TrackDetailsCard :showExisting="showExisting" />
      </div>
      <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 my-1">
        <MasteringElements />
      </div>
    </div>


    <!-- Modal -->
    <div v-if="!loadingTrack" class="modal fade" id="confirmModal" tabindex="-1" role="dialog"
      aria-labelledby="confirmModal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="confirmModalTitle">{{ getCategoryTitle(details.category) }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to use 1 credit of {{ creditByCategory }} {{ getCategoryTitle(details.category) }}
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button @click="payByCredit" type="button" class="btn btn-primary">Yes, continue</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrackDetailsCard from "@/components/TrackDetailsCard.vue";

import MasteringElements from "@/components/MasteringElements.vue";
import { getTrackById, payTrackByCredit } from "../services/track";
import { getUserCredits } from "../services/credits";

const creditsKeyPair = {
  'stereo': 'sqty',
  'track': 'mqty',
  'atmos': 'aqty',
  'mastering': 'mstqty'
}

const categoryTitleKeyPair = {
  stereo: "Full Stem Mix",
  track: "2 Track Mix",
  atmos: "Atmos Mix",
  mastering: "Master",
};

export default {
  components: {
    TrackDetailsCard,
    MasteringElements,
  },
  data() {
    return {
      creditByCategory: null,
      xhrError: null,
      loadingCredits: true,
      loadingTrack: true,
      details: null
    }
  },
  mounted() {
    getTrackById(parseInt(this.$route.params.id))
      .then(({ data }) => {
        this.details = data;
        let { category } = data;
        getUserCredits()
          .then(({ data: creditData }) => {
            console.log(creditData);
            const trackCategoryUserCredit = creditData[creditsKeyPair[category]];
            this.creditByCategory = trackCategoryUserCredit;
          })
          .catch((error) => {
            if (error.response && error.response.data) {
              this.xhrError = error.response.data.message || "Unexpected error occured. Contact support@getmxd.com"
            } else {
              this.xhrError = "Unexpected error occured. Contact support@getmxd.com"
            }
          })
          .finally(() => {
            this.loadingCredits = false
          })
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          this.xhrError = error.response.data.message || "Unexpected error occured. Contact support@getmxd.com"
        } else {
          this.xhrError = "Unexpected error occured. Contact support@getmxd.com"
        }
      })
      .finally(() => {
        this.loadingTrack = false;
      })
  },
  computed: {
    showExisting() {
      // (this.$route.params.id);
      ///////COMPLETE THE FINAL UPLOAD STEPS  -  SET TRACK STATUS IN DB TO PENDING, ETC.
      return this.$store.state.trackData.trackStatus != "Incomplete" &&
        this.$store.state.trackData.trackStatus != ""
        ? 1
        : 0;
    },
    isRequested() {
      return this.$store.state.trackData.reqReuplaod ? 1 : 0;
    },
  },
  methods: {
    back() {
      this.$router.push({
        name: "dashboard"
      });
    },
    purchaseCredits() {
      // Build link to purchase
      // Shopify version
      let purchasePageID;
      switch (this.details.category) {
        case 'stereo':
          purchasePageID = "p-price-1"
          break;
        case 'track':
          purchasePageID = "p-price-2"
          break;
        case 'atmos':
          purchasePageID = "p-price-3"
          break;
        case 'mastering':
          purchasePageID = "p-price-3"
          break;
      }

      window.open(`https://getmxd.com/pricing#${purchasePageID}`, '_blank')

      // Develop version
    },

    payByCredit() {
      payTrackByCredit(this.details.id).then(r => {
        window.location.reload();
      })
        .catch(error => {
          if (error.response && error.response.data) {
            this.xhrError = error.response.data.message || "Unexpected error occured. Contact support@getmxd.com"
          } else {
            this.xhrError = "Unexpected error occured. Contact support@getmxd.com"
          }
        })
        .finally(() => {
          $('#confirmModal').modal('hide')
        })
    },
    getCategoryTitle(category) {
      return categoryTitleKeyPair[category]
    }
  },
};
</script>

<style scoped>
#confirmModal {
  color: black !important;
  ;
}

.loading-container {
  height: 100vh;
}

.message-action {
  color: rgb(226, 150, 37);
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.step-text {
  color: #2bfed1;
  font-size: 12px;
  font-weight: normal;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.step-description {
  color: #ffffff;
  font-size: 18px;

  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 1.8px;
}
</style>
<style>
.card-header {
  color: #fff;
  font-size: 24px;
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 2.4px;
}

.card-accent-text {
  color: #ffffff;
  font-size: 12px;

  font-weight: normal;
  text-transform: uppercase;
  letter-spacing: 0;
}

.card-accent-info {
  color: #2bfed1;
  font-size: 14px;
  font-family: "Open Sans";
  font-weight: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.card-details-header {
  border-bottom: none !important;
  background: none !important;
}

.info-text {
  color: #fff;
  font-size: 14px;
  font-family: "Open Sans";
  font-weight: normal;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.active-button {
  width: 143px;
  height: 48px;
  background: #2bfed1 !important;
  border-radius: 2px 2px 2px 2px !important;
  color: #282c5a !important;
  font-size: 16px !important;
  font-family: "Open Sans" !important;
  font-weight: bold !important;
  text-transform: uppercase !important;
  letter-spacing: 0 !important;
  border-color: #282c5a;
  cursor: pointer;
}

.active-button-disabled {
  width: 143px;
  height: 48px;
  background: #3b7e70 !important;
  border-radius: 2px 2px 2px 2px !important;
  color: #282c5a !important;
  font-size: 16px !important;
  font-family: "Open Sans" !important;
  font-weight: bold !important;
  text-transform: uppercase !important;
  letter-spacing: 0 !important;
  border-color: #282c5a;
}

.base-button,
.btn-primary {
  background: #2bfed1 !important;
  height: 48px;
  width: 200px;
  border-radius: 50px !important;
  color: #156554 !important;
  font-size: 16px !important;
  font-family: "Open Sans" !important;
  font-weight: bold !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  border-color: #282c5a;
  cursor: pointer;
  transition: all 200ms ease 0s !important;
}

.base-button-disabled,
.btn-primary-disabled {
  background: #3b7e70 !important;
  height: 48px;
  width: 200px;
  border-radius: 2px !important;
  color: #156554 !important;
  font-size: 16px !important;
  font-family: "Open Sans" !important;
  font-weight: bold !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  border-color: #282c5a;
}

.base-button:hover {
  background: #14c49e !important;
  transition: all 200ms ease 0s !important;
}

.base-button-outline,
.btn-secondary {
  background: none !important;
  height: 48px;
  width: 200px;
  border-radius: 2px !important;
  border: solid 1px #2bfed1;
  color: #2bfed1 !important;
  font-size: 16px !important;
  font-family: "Open Sans" !important;
  font-weight: 400 !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  transition: all 200ms ease 0s !important;
  cursor: pointer;
}

.base-button-outline-sm {
  background: none !important;
  padding: 8px 12px;
  border-radius: 2px !important;
  border: solid 1px #2bfed1;
  color: #2bfed1 !important;
  font-size: 12px !important;
  font-family: "Open Sans" !important;
  font-weight: 400 !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  cursor: pointer;
  transition: all 200ms ease 0s !important;
}

.base-button-outline-sm:hover,
.base-button-outline:hover {
  /*Inverse */
  /* background: #14c49e !important;
  color: #282c5a !important;
  border-color: #282c5a !important; */

  /*Dark 1*/
  /* background: #1a1d3c !important;
  border-color: #1a1d3c !important; */

  /*Dark 2 */
  /* background: #1f2348 !important;
  border-color: #1f2348 !important; */

  /*Light */
  /* background: #383d7d !important; */
  opacity: 0.6 !important;

  transition: all 200ms ease 0s !important;
}

.inactive-button {
  width: 143px;
  height: 48px;
  background: #1f2348;
  border-radius: 2px 2px 2px 2px;
  color: #282c5a;
  font-size: 16px;
  font-family: "Open Sans";
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0;
  border-color: #1f2348;
}
</style>
